<div class="company-block" *ngIf="scoreVisible">
  <ng-container *ngIf="isEsgSetup()">
    <div class="company-menu">
      <div class="menu-left" *ngIf="!qparam?.score">ESG Events</div>
      <div class="menu-left" *ngIf="qparam?.score">
        <span class="score-icon">
          <svg-icon src="{{ 'assets/icon/o_esg.svg' }}"></svg-icon>
        </span>
        <span>ESG Events</span>
      </div>
      <div
        class="menu-window"
        *ngIf="rollingWindowDays"
        [matTooltip]="rollingWindowTooltip"
      >
        {{ rollingWindowDays }}d
      </div>
    </div>
    <div
      #expansionContainer
      class="company-treemap"
      *ngIf="iready['Score Events']; else loadingScoreEvents"
    >
      <mat-accordion>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header [style.height.px]="contentHeight">
            <mat-panel-title> Overall </mat-panel-title>
            <mat-panel-description
              [style.color]="scoresESG.scoreESG | colorScore2"
            >
              {{ scoresESG.scoreESG }} / 10
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="panel-table-header">
              <div>Events</div>
              <div>No. Articles</div>
            </div>
            <div class="panel-table-body">
              <ng-container
                *ngFor="
                  let item of scoreEventsESG
                    | orderBy: '-contrib_amount_importance'
                "
              >
                <app-event-row
                  *ngIf="item.contrib_amount > 0"
                  [elementId]="item.id + '-esg'"
                  [name]="item.name"
                  [value]="item.contrib_amount_importance"
                  [prevValue]="item.contrib_amount_importance_prev"
                  [valueFormat]="'percent'"
                  [maxValue]="panelMax(scoreEventsESG)"
                  [impact]="item.impact ?? 1"
                  [active]="qparam?.eventid === item.id"
                  [sole]="soleMosaic"
                  [mobile]="(screenSize$ | async)?.isMobile"
                  [series]="eventSeriesMap?.get(item.id)"
                  [microTimeframe]="microTimeframe"
                  [bandDays]="selectedTimeframeDays"
                  [bucketDays]="sparklineBucketDays"
                  [showSparkline]="eventSeriesMap?.size > 0 && soleMosaic"
                  [showTemporality]="hasTemporalityAnalytics && soleMosaic"
                  [temporalityWidths]="temporalityWidths(item.id)"
                  (rowClick)="iScoreEvent(item)"
                ></app-event-row>
              </ng-container>
            </div>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header [style.height.px]="contentHeight">
            <mat-panel-title> Environmental </mat-panel-title>
            <mat-panel-description
              [style.color]="scoresESG.scoreE | colorScore2"
            >
              {{ scoresESG.scoreE }} / 10
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="panel-table-header">
              <div>Events</div>
              <div>No. Articles</div>
            </div>
            <div class="panel-table-body">
              <ng-container
                *ngFor="
                  let item of scoreEventsE
                    | orderBy: '-contrib_amount_importance'
                "
              >
                <app-event-row
                  *ngIf="item.contrib_amount > 0"
                  [name]="item.name"
                  [value]="item.contrib_amount_importance"
                  [prevValue]="item.contrib_amount_importance_prev"
                  [valueFormat]="'percent'"
                  [maxValue]="panelMax(scoreEventsE)"
                  [impact]="item.impact ?? 1"
                  [active]="qparam?.eventid === item.id"
                  [sole]="soleMosaic"
                  [mobile]="(screenSize$ | async)?.isMobile"
                  [series]="eventSeriesMap?.get(item.id)"
                  [microTimeframe]="microTimeframe"
                  [bandDays]="selectedTimeframeDays"
                  [bucketDays]="sparklineBucketDays"
                  [showSparkline]="eventSeriesMap?.size > 0 && soleMosaic"
                  [showTemporality]="hasTemporalityAnalytics && soleMosaic"
                  [temporalityWidths]="temporalityWidths(item.id)"
                  (rowClick)="iScoreEvent(item)"
                ></app-event-row>
              </ng-container>
            </div>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header [style.height.px]="contentHeight">
            <mat-panel-title> Social </mat-panel-title>
            <mat-panel-description
              [style.color]="scoresESG.scoreS | colorScore2"
            >
              {{ scoresESG.scoreS }} / 10
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="panel-table-header">
              <div>Events</div>
              <div>No. Articles</div>
            </div>
            <div class="panel-table-body">
              <ng-container
                *ngFor="
                  let item of scoreEventsS
                    | orderBy: '-contrib_amount_importance'
                "
              >
                <app-event-row
                  *ngIf="item.contrib_amount > 0"
                  [name]="item.name"
                  [value]="item.contrib_amount_importance"
                  [prevValue]="item.contrib_amount_importance_prev"
                  [valueFormat]="'percent'"
                  [maxValue]="panelMax(scoreEventsS)"
                  [impact]="item.impact ?? 1"
                  [active]="qparam?.eventid === item.id"
                  [sole]="soleMosaic"
                  [mobile]="(screenSize$ | async)?.isMobile"
                  [series]="eventSeriesMap?.get(item.id)"
                  [microTimeframe]="microTimeframe"
                  [bandDays]="selectedTimeframeDays"
                  [bucketDays]="sparklineBucketDays"
                  [showSparkline]="eventSeriesMap?.size > 0 && soleMosaic"
                  [showTemporality]="hasTemporalityAnalytics && soleMosaic"
                  [temporalityWidths]="temporalityWidths(item.id)"
                  (rowClick)="iScoreEvent(item)"
                ></app-event-row>
              </ng-container>
            </div>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header [style.height.px]="contentHeight">
            <mat-panel-title> Governance </mat-panel-title>
            <mat-panel-description
              [style.color]="scoresESG.scoreG | colorScore2"
            >
              {{ scoresESG.scoreG }} / 10
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="panel-table-header">
              <div>Events</div>
              <div>No. Articles</div>
            </div>
            <div class="panel-table-body">
              <ng-container
                *ngFor="
                  let item of scoreEventsG
                    | orderBy: '-contrib_amount_importance'
                "
              >
                <app-event-row
                  *ngIf="item.contrib_amount > 0"
                  [name]="item.name"
                  [value]="item.contrib_amount_importance"
                  [prevValue]="item.contrib_amount_importance_prev"
                  [valueFormat]="'percent'"
                  [maxValue]="panelMax(scoreEventsG)"
                  [impact]="item.impact ?? 1"
                  [active]="qparam?.eventid === item.id"
                  [sole]="soleMosaic"
                  [mobile]="(screenSize$ | async)?.isMobile"
                  [series]="eventSeriesMap?.get(item.id)"
                  [microTimeframe]="microTimeframe"
                  [bandDays]="selectedTimeframeDays"
                  [bucketDays]="sparklineBucketDays"
                  [showSparkline]="eventSeriesMap?.size > 0 && soleMosaic"
                  [showTemporality]="hasTemporalityAnalytics && soleMosaic"
                  [temporalityWidths]="temporalityWidths(item.id)"
                  (rowClick)="iScoreEvent(item)"
                ></app-event-row>
              </ng-container>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </ng-container>

  <ng-container *ngIf="!isEsgSetup()">
    <div class="company-menu">
      <div class="menu-left" *ngIf="this.customScore && !qparam?.score">
        {{ scoreEventsTitle() }}
      </div>
      <div class="menu-left" *ngIf="!this.customScore && !qparam?.score">
        {{ scoreEventsTitle() }}
      </div>
      <div class="menu-left" *ngIf="qparam?.score">
        <span
          *ngIf="['eb_sim', 'eb_sim_risk'].includes(qparam.score)"
          class="score-icon"
        >
          <svg-icon
            src="{{ 'assets/icon/o_' + qparam.score + '.svg' }}"
          ></svg-icon>
        </span>
        <span>{{ scoreEventsTitle() }}</span>
      </div>
      <div
        class="menu-window"
        *ngIf="rollingWindowDays"
        [matTooltip]="rollingWindowTooltip"
      >
        {{ rollingWindowDays }}d
      </div>
    </div>
    <div
      class="company-treemap"
      *ngIf="iready['Score Events']; else loadingScoreEvents"
    >
      <ng-container
        *ngFor="let item of scoreEvents | orderBy: '-contrib_amount_importance'"
      >
        <app-event-row
          *ngIf="item.contrib_amount > 0"
          [elementId]="item.id + '-'"
          [name]="item.name"
          [value]="item.contrib_amount_importance"
          [prevValue]="item.contrib_amount_importance_prev"
          [valueFormat]="'percent'"
          [maxValue]="panelMax(scoreEvents)"
          [impact]="item.impact ?? 1"
          [active]="qparam?.eventid === item.id"
          [sole]="soleMosaic"
          [mobile]="(screenSize$ | async)?.isMobile"
          [series]="eventSeriesMap?.get(item.id)"
          [microTimeframe]="microTimeframe"
          [bandDays]="selectedTimeframeDays"
          [bucketDays]="sparklineBucketDays"
          [showSparkline]="eventSeriesMap?.size > 0 && soleMosaic"
          [showTemporality]="hasTemporalityAnalytics && soleMosaic"
          [temporalityWidths]="temporalityWidths(item.id)"
          (rowClick)="iScoreEvent(item)"
        ></app-event-row>
      </ng-container>
      <div *ngIf="scoreEvents === 0" class="noevent">NO EVENTS</div>
    </div>
  </ng-container>

  <ng-template #loadingScoreEvents>
    <div class="loading" *ngIf="loading['Score Events']">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
    <div class="nodata" *ngIf="nodata['Score Events']">NO DATA AVAILABLE</div>
    <div
      class="nodata"
      *ngIf="!nodata['Score Events'] && !loading['Score Events']"
    >
      NO RESULTS FOUND, CHECK APPLIED FILTERS
    </div>
  </ng-template>
</div>
